var ContextRegistry = function(initialContext) {
  this._contextMapping = initialContext || {};
};

ContextRegistry.prototype.setContext = function(name, data) {
  this._contextMapping[name] = data;
};

ContextRegistry.prototype.clearContext = function(name) {
  delete this._contextMapping[name];
};

ContextRegistry.prototype.list = function() {
  return objectValues(this._contextMapping);
};

function objectValues(obj) {
  return Object.keys(obj).map(function(key) {
    return obj[key];
  });
}

module.exports = ContextRegistry;
